import ReactGA from 'react-ga4'
import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { fetchGuideBySlug } from '../../services/articleAPISevicesUsingFetch'
import { Typography, Box, Skeleton,Snackbar, Alert } from '@mui/material'
import Error from '../Error'
import DOMPurify from 'dompurify'
import parse from 'html-react-parser'
// import usePageTracking from '../../services/usePageTracking'
import GuideArticle from './GuideArticle'

const GuideDetail = () => {
  // usePageTracking()

  const { slug } = useParams()
  const [snackbarOpen, setSnackbarOpen] = useState(false)
      const [snackbarMessage, setSnackbarMessage] = useState('') // Feedback submitted successfully 😄
      const [snackbarSeverity, setSnackbarSeverity] = useState('success') // success or error
    const handleSnackbarClose = useCallback((event, reason) => {
      if (reason === 'clickaway') return
      setSnackbarOpen(false)
    }, [])
  
    const showSnackbar = useCallback((message, severity) => {
      setSnackbarMessage(message)
      setSnackbarSeverity(severity)
      setSnackbarOpen(true)
    }, [])
  // const [guide, setGuide] = useState(null)
  // const [error, setError] = useState(null)
  // const [loading, setLoading] = useState(true)

  // useEffect(() => {
  //   const getGuide = async () => {
  //     try {
  //       const data = await fetchGuideBySlug(slug)
  //       setGuide(data)
  //     } catch (error) {
  //       setError(error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }

  //   getGuide()
  // }, [slug])

  // if (loading) {
  //   return (
  //     <Box sx={{ padding: 2 }}>
  //       <Skeleton variant='text' width='80%' height={40} />
  //       <Skeleton
  //         variant='text'
  //         width='60%'
  //         height={30}
  //         sx={{ marginTop: 2 }}
  //       />
  //       <Skeleton
  //         variant='rectangular'
  //         width='100%'
  //         height={400}
  //         sx={{ marginTop: 2 }}
  //       />
  //     </Box>
  //   )
  // }
  // if (error) {
  //   return <Error error={error} />
  // }
  // return (
  //   guide && <GuideArticle article={guide}/>

  // )
  const article = useMemo(() => ({ slug }), [slug])
  return (
    <>
      <GuideArticle article={article} showSnackbar={showSnackbar} />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1500}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{
            mt: 5.5,
            width: '100%',
            // backgroundColor:
            //   snackbarSeverity === 'warning'
            //     ? '#ffcf51'
            //     : snackbarSeverity === 'error'
            //     ? '#d32f2f'
            //     : snackbarSeverity === 'success'
            //     ? '#43a047'
            //     : '#232536',
            // color: snackbarSeverity === 'warning' ? '#232536' : '#fff',
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  )
}
export default GuideDetail
